import { render, staticRenderFns } from "./template_edit.vue?vue&type=template&id=8555ea52&scoped=true&"
import script from "./template_edit.vue?vue&type=script&lang=js&"
export * from "./template_edit.vue?vue&type=script&lang=js&"
import style0 from "./template_edit.vue?vue&type=style&index=0&id=8555ea52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8555ea52",
  null
  
)

export default component.exports